export const routes = (prefix) => [
    {
        path: `/${prefix}/audittrail`,
        name: `${prefix}.audittrail.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.audittrail.index`,
                PageDescription: "Admin: Audit Trail",
            },
        }
    },
];
